import segment from './segment'
import crowdtwist from './crowdtwist'
import optimove from './optimove'
import activedirectory from './activedirectory'
import kochava from './kochava'
import salesforce from './salesforce'
import sftp from './sftp'
import sbtech from './sbtech'
import shopify from './shopify'
import mixpanel from './mixpanel'
import lithium from './lithium'
import lithiumv2 from './lithiumv2'
import webhook from './webhook'
import tglab from './tglab'
import gcs from './gcs'
import sportradar from './sportradar'
import meta from './meta'
import googleads from './googleads'
import magento from './magento'
import alira from './alira'
import gig from './gig'
import openbet from './openbet'
import dynamicpromotions from './dynamicpromotions'
import kwiff from './kwiff'
import betsson from './betsson'
import igt from './igt'
import opapwebhook from './opapwebhook'
import oasis from './oasis'
import otp from './otp'
import s3 from './s3'
import warply from './warply'

export default {
  segment,
  crowdtwist,
  optimove,
  activedirectory,
  kochava,
  salesforce,
  sftp,
  sbtech,
  shopify,
  mixpanel,
  lithium,
  lithiumv2,
  webhook,
  tglab,
  gcs,
  sportradar,
  meta,
  googleads,
  magento,
  alira,
  gig,
  openbet,
  kwiff,
  betsson,
  dynamicpromotions,
  igt,
  opapwebhook,
  oasis,
  s3,
  otp,
  warply
}



// WEBPACK FOOTER //
// ./src/modules/integrations/types/index.js